import { useCallback } from 'react';
import { useSession } from '../SessionProvider';
import { displayMarks } from './displayMarks';

export const useDisplayMarks = () => {
  const { olSession, sessionId } = useSession();

  const markTarget = useCallback(
    async (colorCode: string = 'FFCC99') => {
      if (!sessionId) {
        throw new Error('Session ID is not available');
      }
      await displayMarks(olSession, sessionId, colorCode, true);
    },
    [olSession, sessionId]
  );

  const unmarkTarget = useCallback(async () => {
    if (!sessionId) {
      throw new Error('Session ID is not available');
    }
    await displayMarks(olSession, sessionId, '', false);
  }, [olSession, sessionId]);

  return {
    markTarget,
    unmarkTarget,
  };
};
